<section class="table-page plan-form-modal">
  <header class="plan-form-modal__header">
    <h2>{{ titulo }}</h2>
    <p *ngIf="esAlta">El cliente podrá repartir este módulo a su gente en cuanto se guarde.</p>
    <p *ngIf="!esAlta">{{ plan.usuariosAsignados }} licencias ocupadas de {{ data.plan?.cantidadUsuarios }}.</p>
  </header>

  <div class="plan-form-modal__body">
    <div class="plan-form-modal__grid">
      <mat-form-field appearance="outline" class="table-page__field plan-form-modal__wide" *ngIf="esAlta">
        <mat-label>Módulo</mat-label>
        <mat-select [(ngModel)]="plan.sitio" [disabled]="cargandoModulos">
          <mat-option *ngFor="let modulo of modulos" [value]="modulo.nombre">{{ modulo.nombre }}</mat-option>
        </mat-select>
        <mat-hint *ngIf="cargandoModulos">Consultando módulos…</mat-hint>
        <mat-hint *ngIf="!cargandoModulos && modulos.length === 0">Este cliente ya tiene vigentes todos los módulos del catálogo.</mat-hint>
        <mat-hint *ngIf="!cargandoModulos && modulos.length > 0">Sólo aparecen los que aún no tienen plan vigente.</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" class="table-page__field">
        <mat-label>Cupo de usuarios</mat-label>
        <input matInput type="number" [min]="minimoCupo" step="1" [(ngModel)]="plan.cantidadUsuarios" aria-label="Cupo de usuarios" />
        <mat-hint *ngIf="!cupoInsuficiente">Cuántas personas puede tener el cliente en este módulo.</mat-hint>
        <mat-hint *ngIf="cupoInsuficiente" class="plan-form-modal__error">
          No puede ser menor que las {{ plan.usuariosAsignados }} licencias ya ocupadas.
        </mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" class="table-page__field">
        <mat-label>Vigente hasta</mat-label>
        <input matInput type="date" [(ngModel)]="plan.vigencia" aria-label="Vigente hasta" />
        <mat-hint>Rige todo ese día. Vencido, el cliente deja de ver el módulo.</mat-hint>
      </mat-form-field>
    </div>

    <p class="plan-form-modal__nota" *ngIf="!esAlta">
      El módulo no se cambia: los perfiles ya repartidos cuelgan de él. Para otro módulo, contrate otro plan.
    </p>
  </div>

  <footer class="plan-form-modal__footer" mat-dialog-actions>
    <button type="button" mat-raised-button class="app-form-btn app-form-btn--secondary app-form-btn--compact"
            [disabled]="guardando" (click)="cancelar()">
      Cancelar
    </button>
    <button type="button" mat-raised-button class="app-form-btn app-form-btn--primary app-form-btn--compact"
            [disabled]="!puedeGuardar" (click)="guardar()">
      <span class="material-icons">save</span>
      {{ guardando ? "Guardando…" : esAlta ? "Contratar" : "Guardar" }}
    </button>
  </footer>
</section>
